import React from 'react';
import { ExtendedHtmlContentContainer } from 'components/ExtendedContent/ExtendedHtmlContentContainer';

export const IFrameModalComponent = ({ internalHtmlInfo }) => {
    return <ExtendedHtmlContentContainer toolbarOpen={internalHtmlInfo.toolbarOpen}>
        <iframe title={internalHtmlInfo.src} src={internalHtmlInfo.src} width="100%" height="100%" ></iframe>
    </ExtendedHtmlContentContainer>
};
